import React, { useState, useEffect, useContext, Fragment } from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import { Button } from 'react-bootstrap';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';

const ApprovalList = ({
  approvalList,
  getInspectionApprovalList,
  acceptApproval,
  rejectApproval,
  getListFilterData,
  filterDropdownList = null,
  fetchZones,
  getFetchZones = null,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState();
  const [isModal, setIsModal] = useState(false);
  const [actionData, setActionData] = useState();
  const [isSuccessModel, setIsSuccessModel] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isStatusSuccess, setIsStatusSuccess] = useState(false);

  const input = {
    remarks: '',
  };
  const [remarks, setRemarks] = useState(input);

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images?.Filter} alt="" />
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  useEffect(() => {
    if (getInspectionApprovalList !== null) {
      (async () => {
        setIsLoading(true);
        await getInspectionApprovalList(null, 1);
        setIsLoading(false);
      })();
    }
  }, [getInspectionApprovalList]);

  const Headers = [
    'Site Number',
    'Contract No',
    'Client Name',
    'Created By',
    'Requested On',
    'Action',
  ];

  useEffect(() => {
    const tableData = [
      'id',
      'site_no',
      'comm_id',
      'client_name',
      'user_name',
      'created_at',
    ];

    if (approvalList !== {} && approvalList.data) {
      // console.log(approvalList.resultSets);
      const data = approvalList.data.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
            element.lead_type_id == 1 
            ? {
              Action: [
                { name: 'View Details', link: '/dashboard/inspection-details'},
               ]
              }  
            : {
              Action: [
                { name: 'View Details', link: '/dashboard/inspection-details'},
              ]
            }, 
          
        )
      );
      data && setListData(data);
      setPageCount(Math.ceil(approvalList.total / approvalList.per_page));
    }
  }, [approvalList]);

  const updateApproval = async (data) => {
    setActionData(data);
    if (data.action === 'accept') {
      const requestData = {
        lead_id: data.actionObj.id,
        comm_id: data.actionObj.comm_id,
        remarks: '',
      };
      setIsLoading(true);
      await acceptApproval(requestData).then(async (response) => {
        if (response) {
          await getInspectionApprovalList(null, 1);
          setIsLoading(false);
          setIsModal(true);
        }else{
          setIsLoading(false);
        }
      });
    } else {
      setIsModal(true);
      setIsLoading(false);
    }
  };

  const handleContinue = async () => {
    setIsModal(false);
    const requestData = {
      lead_id: actionData.actionObj.id,
      comm_id: actionData.actionObj.comm_id,
      remarks: remarks.remarks,
    };
    setIsLoading(true);
    await rejectApproval(requestData).then(async (response) => {
      setIsLoading(false);
      if (response) {
        await getInspectionApprovalList(null, 1);
        setIsSuccessModel(true);
      }
    });
  };
  const handleModalHide = () => setIsModal(false);
  const handleRejectModalHide = () => setIsSuccessModel(false);

  const successIconBox = (text, func) => {
    return (
      <div className="text-center">
        <div className="success">
          <img src={Images?.tick} alt="" />
        </div>
        <h5>{text}</h5>
        <Link to="#" onClick={func} className="btn btn-transparent">
          {localization.returnToApproval}{' '}
          <img src={Images?.ArrowRight} alt="" />
        </Link>
      </div>
    );
  };

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await getInspectionApprovalList(filter, val.selected + 1);
    setIsLoading(false);
  };

  useEffect(() => {
    (async () => {
      await getListFilterData(3);
    })();
  }, []);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const getZones = (val) => {
    if (val) fetchZones(val);
  };

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    await getInspectionApprovalList(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  const closeSuccess = () => {
    setIsLoading(true);
    setIsStatusSuccess(!isStatusSuccess);
    setIsLoading(false);
  };

  return (
    <Layout
      title={localization.approvals}
      // Buttons={headerBtns}
      isLoading={isLoading}
    >
      {console.log(approvalList)}
      <TableSection
        data={listData}
        isId={false}
        headers={Headers}
        detailList={approvalList && approvalList.data}
        onChange={(data) => updateApproval(data)}
        srNo={approvalList?.from}
        pageCount={pageCount}
        onPageChange={onPageChange}
      />

      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={'8'}
        getZones={(val) => getZones(val)}
        listFilterData={filterDropdownList && filterDropdownList.data}
        zones={getFetchZones && getFetchZones.data}
        filterPreSalesListing
      />

      <ModalPop
        title={localization.updatedSuccessfully}
        show={isStatusSuccess}
        handleModalHide={closeSuccess}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.leadStatusupdatedsuccessfully}</h5>
          <Link to="#" onClick={closeSuccess} className="btn btn-transparent">
            {localization.continue}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>

      <ModalPop
        title={
          actionData && actionData.action === 'reject'
            ? localization.rejectConf
            : localization.conf
        }
        show={isModal}
        handleModalHide={handleModalHide}
        actionData={actionData}
      >
        {actionData && actionData.action === 'reject' ? (
          <Fragment>
            <div className="modal-body">
              <div className="text-center">
                <h5>{localization.rejectApproval}</h5>
                <div className="form-group">
                  {/* <TextAreaInput
                    type="text"
                    label={localization.addRemark}
                    required
                    isStarRequired={true}
                    handleChange={(e) => {
                      setRemarks({ ...setRemarks, remarks: e.target.value });
                    }}
                  /> */}
                  <ConstantInput
                    label={localization.addRemark}
                    required
                    isStarRequired={true}
                    type="text"
                    handleChange={(val) => {
                      setRemarks({ ...setRemarks, remarks: val });
                    }}
                  />
                </div>
                <Button
                  className="btn btn-primary"
                  onClick={handleContinue}
                  disabled={!remarks.remarks}
                >
                  {localization.continue}{' '}
                  <img src="../images/arrow-right.png" alt="" />
                </Button>
              </div>
            </div>
          </Fragment>
        ) : (
          <Fragment>
            {successIconBox(localization.approveSuccess, handleModalHide)}
          </Fragment>
        )}
      </ModalPop>
      <ModalPop
        title={localization.rejectSuccessfully}
        show={isSuccessModel}
        handleModalHide={handleRejectModalHide}
      >
        {successIconBox(localization.approveReject, handleRejectModalHide)}
      </ModalPop>
    </Layout>
  );
};

ApprovalList.propTypes = {
  approvalList: PropTypes.any,
  getInspectionApprovalList: PropTypes.any,
  acceptApproval: PropTypes.any,
  rejectApproval: PropTypes.any,
};

export default ApprovalList;
